/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterAssignedTo = new PostFilter(
  [['guid', PostFilterComparison.eq]],
  'assigned_to',
);
